import React, { FC } from 'react'

import { XMarkIcon } from '@heroicons/react/20/solid'

import { useCurrentApplication } from '@/graphql/services/application'
import { useDeleteApplicationPartiesMutation } from '@/services/v2-application/applicationParties'

export type DeleteFileContact = {
  onClose: () => void
  toBeDeletedFileContact: number
}

export const DeleteContactModal: FC<DeleteFileContact> = (props) => {
  const { onClose, toBeDeletedFileContact } = props
  const [deleteParty, { isLoading: isDeletePartyLoading }] = useDeleteApplicationPartiesMutation()
  const { data: application } = useCurrentApplication()

  return (
    <div
      id='overlay'
      className='top-0 left-0 fixed w-screen h-screen bg-gray-400/60 z-50 flex items-center justify-center'
    >
      <div className='flex flex-col gap-4 w-[40%] bg-white rounded py-4'>
        <div className='flex justify-between border-b-2 px-4 pb-2'>
          <h4 className='font-bold'>Delete file contact</h4>
          <XMarkIcon
            className='cursor-pointer'
            width={20}
            onClick={() => onClose()}
          />
        </div>
        {/* Main Content */}
        <div className='px-8'>
          <div className='flex py-4 px-4 flex-col'>
            <p>Do you really want to delete?</p>
            <p className='text-xs text-error italic mt-1'>
              Forms or views may depend on this contact info.
            </p>
          </div>
          <div className='flex justify-between items-end px-4'>
            <a
              className='text-sm hover:underline cursor-pointer'
              onClick={() => onClose()}
            >
              Cancel
            </a>
            <button
              className='rounded bg-error disabled:bg-sky-300 text-white py-2 px-4'
              type='button'
              disabled={isDeletePartyLoading}
              onClick={() => {
                deleteParty({ application_uuid: application?.uuid, uuid: toBeDeletedFileContact })
                onClose()
              }}
            >
              {isDeletePartyLoading ? `Loading` : `Delete`}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
